import { useState } from 'react';
import PrimaryButton from '../../../../atoms/buttons/PrimaryButton.jsx';
import { Formik, Form } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import { useLoginFormData } from './useLoginFormData.js';
import { useLoginYupValidations } from './useLoginYupValidations.js';
import { LoginMapFormData } from './LoginMapFormData.jsx';
import { useRegisterFormData } from '../geolocation-register/useRegisterFormData.js';
import { createMessageSlice } from '../../../../../store/slices/createMessageSlice.js';
import PATHS from '../../../../../store/models/routes.js';
import useBackendErrorsMessages from '../../../../molecules/messageManager/useBackendErrorsMessages.js';
import { backendErrorMessageProcessor } from '../../../../molecules/messageManager/backendErrorMessageProcessor.js';
import postService from '../../../../../services/post_services/postService.js';

const LoginForm = () => {
  const { loginInitialValues, loginIntlFormData, loginIntlButtons, loginFormMessages } = useLoginFormData();
  const { loginRegisterSchema } = useLoginYupValidations();
  const { registerIntlButtons } = useRegisterFormData();
  const { addMessage } = createMessageSlice();
  const { backendErrors } = useBackendErrorsMessages();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [submittingForm, setSubmittingForm] = useState(false);

  const handleFormSubmit = async (values) => {
    setSubmittingForm(true);
    addMessage({ type: 'submitting', content: loginFormMessages.submittingMessage });
    const url = '/auth/login-user';
    const response = await postService(url, values);
    if (response.success) {
      const { token, role } = response.data;
      localStorage.setItem('token', token);
      localStorage.setItem('role', role);
      addMessage({ type: 'success', content: loginFormMessages.successMessage });
      if (role === 'admin') navigate(PATHS.ADMIN.ROOT);
      else navigate(PATHS.HOME);
    } else {
      const errorsTranslated = backendErrorMessageProcessor(backendErrors, response.errors);
      addMessage({ type: 'error', content: errorsTranslated });
    }
    setSubmittingForm(false);
  };

  return (
    <div className='form-box'>
      <Formik initialValues={loginInitialValues} validationSchema={loginRegisterSchema} onSubmit={handleFormSubmit}>
        {({ errors, touched }) => (
          <Form className='form'>
            <LoginMapFormData loginIntlFormData={loginIntlFormData} errors={errors} touched={touched} showPassword={showPassword} setShowPassword={setShowPassword} />
            <PrimaryButton type='submit' disabled={submittingForm} id='largePrimaryButtonForLogin'>
              {loginIntlButtons.buttonSend}
            </PrimaryButton>
            <Link
              to={PATHS.ADMIN.GEOLOCATION_REGISTER}
              style={{ marginTop: '20px', textDecoration: 'none', display: 'inline-block', cursor: 'pointer' }}
            >
              {registerIntlButtons.buttonSend}
            </Link>

          </Form>
        )}
      </Formik>
    </div>
  );
};

export default LoginForm;
